import { Alert } from '@sr/ui-library';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useParams } from 'react-router-dom';
import { queryOptionsGetWorkspace } from '../api/workspaces/workspaceApi';
import { AppChooser } from '../components/AppChooser';
import ErrorPage from '../components/ErrorPage';
// TODO(MSR3-sidebar-cleanup): Remove IfFeatureEnabledMSR3 import when fully migrated
import { IfFeatureEnabledMSR3 } from '../components/IfFeatureEnabledMSR3';
import { MembershipApplicationGate } from '../components/MembershipApplicationGate';
import { Sidebar } from '../components/Sidebar';
// TODO(MSR3-sidebar-cleanup): Remove WorkspaceSidebar import when fully migrated
import { WorkspaceSidebar } from '../components/navigation/WorkspaceSidebar';
import { useCurrentUserAuth } from '../hooks/useCurrentUserAuth';
import { reduxServices } from '../reducers/reduxServices';
import { useTypedSelector } from '../stateStore';
import { userIsInCustomerView } from '../utils/helpers/common';
import DefaultLayoutV3 from './DefaultLayoutV3';

function WorkspaceLayout() {
  const { workspaceId } = useParams();

  const { data: workspace } = useQuery(queryOptionsGetWorkspace(workspaceId));
  const { currentUser } = useCurrentUserAuth();
  const showErrorPage = useTypedSelector(
    reduxServices.globalState.selectors.showErrorPage,
  );

  const titlePage = location.pathname.includes('/titles');

  return (
    <>
      <DefaultLayoutV3
        hasBreadcrumbs={titlePage}
        initialCrumb={workspace?.workspaceName}
        // TODO(MSR3-sidebar-cleanup): Replace with just `navbarElement={<Sidebar />}`
        navbarElement={
          <>
            <IfFeatureEnabledMSR3 name="msr3.customerApp.sidebar">
              <Sidebar />
            </IfFeatureEnabledMSR3>
            <IfFeatureEnabledMSR3
              name="msr3.customerApp.sidebar"
              isEnabled="false"
            >
              <WorkspaceSidebar workspaceId={workspaceId || workspace?._id} />
            </IfFeatureEnabledMSR3>
          </>
        }
      >
        {userIsInCustomerView(currentUser) && (
          <div className="px-5 pt-8 xl:mx-auto xl:max-w-screen-4xl">
            <Alert
              actionButtonProps={{
                children: 'Close customer view',
                onClick: () => window.close(),
              }}
              hasActionButton
              variant="warning"
            >
              Hi <strong>{currentUser?.firstName}</strong>, You are viewing{' '}
              <strong>{workspace?.workspaceName}</strong> workspace in customer
              view. Some customer actions are not available.
            </Alert>
          </div>
        )}

        {/* App Chooser - redirects royalties-only workspaces to MyScreenrights */}
        <AppChooser workspace={workspace} />

        <DefaultLayoutV3.Body>
          {showErrorPage ? <ErrorPage /> : <Outlet context={{ workspaceId }} />}
        </DefaultLayoutV3.Body>
      </DefaultLayoutV3>

      {/* Site-wide membership modal for ApplicationSent status.
          Shared with MSR3BaseLayout so the prompt is not ?v= dependent. */}
      <MembershipApplicationGate />
    </>
  );
}

export default WorkspaceLayout;
